// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════════════
   TrackingSimulator.css  –  Developer simulator page styles
   ════════════════════════════════════════════════════════════════════ */

.sim-root,
.sim-root * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Inter', system-ui, sans-serif;
}

:root {
  --sim-bg:       #080f1a;
  --sim-surface:  #0f1c2e;
  --sim-surface2: #16253b;
  --sim-border:   rgba(99,102,241,0.18);
  --sim-text:     #e2e8f0;
  --sim-muted:    #64748b;
  --sim-accent:   #6366f1;
  --sim-green:    #10b981;
  --sim-red:      #ef4444;
  --sim-amber:    #f59e0b;
  --sim-radius:   12px;
}

.sim-root {
  min-height: 100dvh;
  background: var(--sim-bg);
  color: var(--sim-text);
  display: flex;
  flex-direction: column;
}

/* ── Header ───────────────────────────────────────────────────────── */
.sim-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 28px;
  background: linear-gradient(135deg, #0c1024, #0f1c2e);
  border-bottom: 1px solid var(--sim-border);
}

.sim-brand {
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(135deg, #a5b4fc, #6366f1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.sim-badge {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 14px;
  border-radius: 99px;
}

.sim-badge-on {
  background: rgba(16,185,129,0.12);
  border: 1px solid rgba(16,185,129,0.3);
  color: var(--sim-green);
}

.sim-badge-off {
  background: rgba(239,68,68,0.12);
  border: 1px solid rgba(239,68,68,0.3);
  color: var(--sim-red);
}

.sim-pulse {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  animation: sim-pulse-anim 1.4s ease-in-out infinite;
}

@keyframes sim-pulse-anim {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%       { opacity: 0.4; transform: scale(0.7); }
}

/* ── Body ─────────────────────────────────────────────────────────── */
.sim-body {
  flex: 1 1;
  display: grid;
  grid-template-columns: 380px 1fr;
  gap: 0;
  overflow: hidden;
  height: calc(100dvh - 53px);
}

/* ── Controls panel ───────────────────────────────────────────────── */
.sim-controls {
  background: var(--sim-surface);
  border-right: 1px solid var(--sim-border);
  overflow-y: auto;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255,255,255,0.08) transparent;
}

.sim-section-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: #818cf8;
  margin-bottom: 4px;
}

.sim-label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  color: var(--sim-muted);
  font-weight: 500;
}

.sim-input {
  background: var(--sim-surface2);
  border: 1px solid var(--sim-border);
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 13px;
  color: var(--sim-text);
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s;
  width: 100%;
}

.sim-input:focus {
  border-color: rgba(99,102,241,0.6);
}

.sim-input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Progress ─────────────────────────────────────────────────────── */
.sim-progress-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sim-progress-label {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: var(--sim-muted);
}

.sim-progress-bar {
  height: 6px;
  background: rgba(255,255,255,0.06);
  border-radius: 99px;
  overflow: hidden;
}

.sim-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--sim-accent), #818cf8);
  border-radius: 99px;
  transition: width 0.4s ease;
}

/* ── Action buttons ───────────────────────────────────────────────── */
.sim-actions {
  display: flex;
  gap: 10px;
}

.sim-btn {
  flex: 1 1;
  padding: 10px 14px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.15s;
  letter-spacing: 0.2px;
}

.sim-btn:hover  { opacity: 0.88; transform: translateY(-1px); }
.sim-btn:active { transform: translateY(0); }
.sim-btn:disabled { opacity: 0.38; cursor: not-allowed; transform: none; }

.sim-btn-start {
  background: linear-gradient(135deg, var(--sim-green), #059669);
  color: #fff;
}

.sim-btn-stop {
  background: linear-gradient(135deg, var(--sim-red), #b91c1c);
  color: #fff;
}

.sim-btn-reset {
  background: var(--sim-surface2);
  color: var(--sim-muted);
  border: 1px solid var(--sim-border);
}

/* ── Tracking link ────────────────────────────────────────────────── */
.sim-link-wrap {
  background: var(--sim-surface2);
  border: 1px solid var(--sim-border);
  border-radius: var(--sim-radius);
  padding: 14px;
}

.sim-link-label {
  font-size: 11px;
  color: var(--sim-muted);
  margin-bottom: 8px;
}

.sim-link-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sim-link {
  flex: 1 1;
  font-size: 11px;
  color: #818cf8;
  word-break: break-all;
  text-decoration: none;
  font-family: 'JetBrains Mono', monospace;
}

.sim-link:hover { text-decoration: underline; }

.sim-btn-copy {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  padding: 0;
  background: rgba(99,102,241,0.15);
  border: 1px solid rgba(99,102,241,0.3);
  color: #a5b4fc;
  border-radius: 8px;
  font-size: 16px;
}

/* ── How to section ───────────────────────────────────────────────── */
.sim-howto {
  background: rgba(99,102,241,0.06);
  border: 1px solid rgba(99,102,241,0.15);
  border-radius: var(--sim-radius);
  padding: 14px;
}

.sim-howto h3 {
  font-size: 12px;
  font-weight: 700;
  color: #818cf8;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.sim-howto ol {
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sim-howto li {
  font-size: 12px;
  color: var(--sim-muted);
  line-height: 1.5;
}

/* ── Log panel ────────────────────────────────────────────────────── */
.sim-log-panel {
  display: flex;
  flex-direction: column;
  background: #050d18;
  overflow: hidden;
}

.sim-log-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 12px;
  border-bottom: 1px solid var(--sim-border);
  flex-shrink: 0;
}

.sim-status-tag {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  padding: 3px 10px;
  border-radius: 99px;
  text-transform: uppercase;
}

.sim-status-idle     { background: rgba(100,116,139,0.15); color: #64748b; border: 1px solid rgba(100,116,139,0.3); }
.sim-status-running  { background: rgba(99,102,241,0.15);  color: #818cf8; border: 1px solid rgba(99,102,241,0.3); }
.sim-status-done     { background: rgba(16,185,129,0.15);  color: #10b981; border: 1px solid rgba(16,185,129,0.3); }
.sim-status-stopped  { background: rgba(245,158,11,0.15);  color: #f59e0b; border: 1px solid rgba(245,158,11,0.3); }
.sim-status-error    { background: rgba(239,68,68,0.15);   color: #ef4444; border: 1px solid rgba(239,68,68,0.3); }

.sim-log {
  flex: 1 1;
  overflow-y: auto;
  padding: 12px 20px 20px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  line-height: 1.7;
  scrollbar-width: thin;
  scrollbar-color: rgba(255,255,255,0.06) transparent;
}

.sim-log-empty {
  color: var(--sim-muted);
  text-align: center;
  margin-top: 40px;
  font-family: 'Inter', sans-serif;
}

.sim-log-entry {
  display: flex;
  gap: 12px;
  padding: 2px 0;
}

.sim-log-ts   { color: #334155; flex-shrink: 0; }
.sim-log-info    .sim-log-msg { color: #94a3b8; }
.sim-log-success .sim-log-msg { color: var(--sim-green); }
.sim-log-warn    .sim-log-msg { color: var(--sim-amber); }
.sim-log-error   .sim-log-msg { color: var(--sim-red); }

/* ── Responsive ───────────────────────────────────────────────────── */
@media (max-width: 768px) {
  .sim-body {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    height: auto;
    min-height: calc(100dvh - 53px);
  }

  .sim-log-panel { min-height: 40vh; }
  .sim-controls  { border-right: none; border-bottom: 1px solid var(--sim-border); }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TrackingSimulator.css"],"names":[],"mappings":"AAAA;;yEAEyE;;AAIzE;;EAEE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,qCAAqC;EACrC,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qDAAqD;EACrD,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,YAAY,YAAY,EAAE,qBAAqB,EAAE;AACnD;;AAEA,wEAAwE;AACxE;EACE,SAAO;EACP,aAAa;EACb,gCAAgC;EAChC,MAAM;EACN,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,wEAAwE;AACxE;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,8DAA8D;EAC9D,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA,kBAAkB,aAAa,EAAE,2BAA2B,EAAE;AAC9D,kBAAkB,wBAAwB,EAAE;AAC5C,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAEzE;EACE,8DAA8D;EAC9D,WAAW;AACb;;AAEA;EACE,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA,wEAAwE;AACxE;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA,kBAAkB,0BAA0B,EAAE;;AAE9C;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iCAAiC;EACjC,sCAAsC;EACtC,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wEAAwE;AACxE;EACE,iCAAiC;EACjC,uCAAuC;EACvC,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,uBAAuB,kCAAkC,EAAE,cAAc,EAAE,uCAAuC,EAAE;AACpH,uBAAuB,iCAAiC,GAAG,cAAc,EAAE,sCAAsC,EAAE;AACnH,uBAAuB,iCAAiC,GAAG,cAAc,EAAE,sCAAsC,EAAE;AACnH,uBAAuB,iCAAiC,GAAG,cAAc,EAAE,sCAAsC,EAAE;AACnH,uBAAuB,gCAAgC,IAAI,cAAc,EAAE,qCAAqC,EAAE;;AAElH;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA,gBAAgB,cAAc,EAAE,cAAc,EAAE;AAChD,gCAAgC,cAAc,EAAE;AAChD,gCAAgC,uBAAuB,EAAE;AACzD,gCAAgC,uBAAuB,EAAE;AACzD,gCAAgC,qBAAqB,EAAE;;AAEvD,wEAAwE;AACxE;EACE;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,YAAY;IACZ,+BAA+B;EACjC;;EAEA,iBAAiB,gBAAgB,EAAE;EACnC,iBAAiB,kBAAkB,EAAE,0CAA0C,EAAE;AACnF","sourcesContent":["/* ════════════════════════════════════════════════════════════════════\n   TrackingSimulator.css  –  Developer simulator page styles\n   ════════════════════════════════════════════════════════════════════ */\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');\n\n.sim-root,\n.sim-root * {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: 'Inter', system-ui, sans-serif;\n}\n\n:root {\n  --sim-bg:       #080f1a;\n  --sim-surface:  #0f1c2e;\n  --sim-surface2: #16253b;\n  --sim-border:   rgba(99,102,241,0.18);\n  --sim-text:     #e2e8f0;\n  --sim-muted:    #64748b;\n  --sim-accent:   #6366f1;\n  --sim-green:    #10b981;\n  --sim-red:      #ef4444;\n  --sim-amber:    #f59e0b;\n  --sim-radius:   12px;\n}\n\n.sim-root {\n  min-height: 100dvh;\n  background: var(--sim-bg);\n  color: var(--sim-text);\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Header ───────────────────────────────────────────────────────── */\n.sim-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 28px;\n  background: linear-gradient(135deg, #0c1024, #0f1c2e);\n  border-bottom: 1px solid var(--sim-border);\n}\n\n.sim-brand {\n  font-size: 18px;\n  font-weight: 700;\n  background: linear-gradient(135deg, #a5b4fc, #6366f1);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.sim-badge {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 5px 14px;\n  border-radius: 99px;\n}\n\n.sim-badge-on {\n  background: rgba(16,185,129,0.12);\n  border: 1px solid rgba(16,185,129,0.3);\n  color: var(--sim-green);\n}\n\n.sim-badge-off {\n  background: rgba(239,68,68,0.12);\n  border: 1px solid rgba(239,68,68,0.3);\n  color: var(--sim-red);\n}\n\n.sim-pulse {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: currentColor;\n  animation: sim-pulse-anim 1.4s ease-in-out infinite;\n}\n\n@keyframes sim-pulse-anim {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50%       { opacity: 0.4; transform: scale(0.7); }\n}\n\n/* ── Body ─────────────────────────────────────────────────────────── */\n.sim-body {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 380px 1fr;\n  gap: 0;\n  overflow: hidden;\n  height: calc(100dvh - 53px);\n}\n\n/* ── Controls panel ───────────────────────────────────────────────── */\n.sim-controls {\n  background: var(--sim-surface);\n  border-right: 1px solid var(--sim-border);\n  overflow-y: auto;\n  padding: 24px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255,255,255,0.08) transparent;\n}\n\n.sim-section-title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.2px;\n  color: #818cf8;\n  margin-bottom: 4px;\n}\n\n.sim-label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--sim-muted);\n  font-weight: 500;\n}\n\n.sim-input {\n  background: var(--sim-surface2);\n  border: 1px solid var(--sim-border);\n  border-radius: 8px;\n  padding: 9px 12px;\n  font-size: 13px;\n  color: var(--sim-text);\n  font-family: inherit;\n  outline: none;\n  transition: border-color 0.2s;\n  width: 100%;\n}\n\n.sim-input:focus {\n  border-color: rgba(99,102,241,0.6);\n}\n\n.sim-input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ── Progress ─────────────────────────────────────────────────────── */\n.sim-progress-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.sim-progress-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  color: var(--sim-muted);\n}\n\n.sim-progress-bar {\n  height: 6px;\n  background: rgba(255,255,255,0.06);\n  border-radius: 99px;\n  overflow: hidden;\n}\n\n.sim-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--sim-accent), #818cf8);\n  border-radius: 99px;\n  transition: width 0.4s ease;\n}\n\n/* ── Action buttons ───────────────────────────────────────────────── */\n.sim-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.sim-btn {\n  flex: 1;\n  padding: 10px 14px;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.15s;\n  letter-spacing: 0.2px;\n}\n\n.sim-btn:hover  { opacity: 0.88; transform: translateY(-1px); }\n.sim-btn:active { transform: translateY(0); }\n.sim-btn:disabled { opacity: 0.38; cursor: not-allowed; transform: none; }\n\n.sim-btn-start {\n  background: linear-gradient(135deg, var(--sim-green), #059669);\n  color: #fff;\n}\n\n.sim-btn-stop {\n  background: linear-gradient(135deg, var(--sim-red), #b91c1c);\n  color: #fff;\n}\n\n.sim-btn-reset {\n  background: var(--sim-surface2);\n  color: var(--sim-muted);\n  border: 1px solid var(--sim-border);\n}\n\n/* ── Tracking link ────────────────────────────────────────────────── */\n.sim-link-wrap {\n  background: var(--sim-surface2);\n  border: 1px solid var(--sim-border);\n  border-radius: var(--sim-radius);\n  padding: 14px;\n}\n\n.sim-link-label {\n  font-size: 11px;\n  color: var(--sim-muted);\n  margin-bottom: 8px;\n}\n\n.sim-link-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sim-link {\n  flex: 1;\n  font-size: 11px;\n  color: #818cf8;\n  word-break: break-all;\n  text-decoration: none;\n  font-family: 'JetBrains Mono', monospace;\n}\n\n.sim-link:hover { text-decoration: underline; }\n\n.sim-btn-copy {\n  flex: 0 0 auto;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  background: rgba(99,102,241,0.15);\n  border: 1px solid rgba(99,102,241,0.3);\n  color: #a5b4fc;\n  border-radius: 8px;\n  font-size: 16px;\n}\n\n/* ── How to section ───────────────────────────────────────────────── */\n.sim-howto {\n  background: rgba(99,102,241,0.06);\n  border: 1px solid rgba(99,102,241,0.15);\n  border-radius: var(--sim-radius);\n  padding: 14px;\n}\n\n.sim-howto h3 {\n  font-size: 12px;\n  font-weight: 700;\n  color: #818cf8;\n  margin-bottom: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n}\n\n.sim-howto ol {\n  padding-left: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.sim-howto li {\n  font-size: 12px;\n  color: var(--sim-muted);\n  line-height: 1.5;\n}\n\n/* ── Log panel ────────────────────────────────────────────────────── */\n.sim-log-panel {\n  display: flex;\n  flex-direction: column;\n  background: #050d18;\n  overflow: hidden;\n}\n\n.sim-log-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px 12px;\n  border-bottom: 1px solid var(--sim-border);\n  flex-shrink: 0;\n}\n\n.sim-status-tag {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  padding: 3px 10px;\n  border-radius: 99px;\n  text-transform: uppercase;\n}\n\n.sim-status-idle     { background: rgba(100,116,139,0.15); color: #64748b; border: 1px solid rgba(100,116,139,0.3); }\n.sim-status-running  { background: rgba(99,102,241,0.15);  color: #818cf8; border: 1px solid rgba(99,102,241,0.3); }\n.sim-status-done     { background: rgba(16,185,129,0.15);  color: #10b981; border: 1px solid rgba(16,185,129,0.3); }\n.sim-status-stopped  { background: rgba(245,158,11,0.15);  color: #f59e0b; border: 1px solid rgba(245,158,11,0.3); }\n.sim-status-error    { background: rgba(239,68,68,0.15);   color: #ef4444; border: 1px solid rgba(239,68,68,0.3); }\n\n.sim-log {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px 20px 20px;\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 12px;\n  line-height: 1.7;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255,255,255,0.06) transparent;\n}\n\n.sim-log-empty {\n  color: var(--sim-muted);\n  text-align: center;\n  margin-top: 40px;\n  font-family: 'Inter', sans-serif;\n}\n\n.sim-log-entry {\n  display: flex;\n  gap: 12px;\n  padding: 2px 0;\n}\n\n.sim-log-ts   { color: #334155; flex-shrink: 0; }\n.sim-log-info    .sim-log-msg { color: #94a3b8; }\n.sim-log-success .sim-log-msg { color: var(--sim-green); }\n.sim-log-warn    .sim-log-msg { color: var(--sim-amber); }\n.sim-log-error   .sim-log-msg { color: var(--sim-red); }\n\n/* ── Responsive ───────────────────────────────────────────────────── */\n@media (max-width: 768px) {\n  .sim-body {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto 1fr;\n    height: auto;\n    min-height: calc(100dvh - 53px);\n  }\n\n  .sim-log-panel { min-height: 40vh; }\n  .sim-controls  { border-right: none; border-bottom: 1px solid var(--sim-border); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
